(function () {
  function init(section) {
    if (section.__nsPairs) return; section.__nsPairs = true;
    var slides = [].slice.call(section.querySelectorAll('[data-pairs-slide]'));
    if (!slides.length) return;
    var thumbs = [].slice.call(section.querySelectorAll('[data-pairs-thumb]'));
    var counter = section.querySelector('[data-pairs-counter]');
    var stage = section.querySelector('[data-pairs-stage]');
    var current = 0;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function show(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var on = k === current;
        s.hidden = !on;
        s.classList.toggle('is-active', on);
        if (on) { [].forEach.call(s.querySelectorAll('img[loading="lazy"]'), function (img) { img.loading = 'eager'; }); }
      });
      thumbs.forEach(function (t, k) {
        var on = k === current;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && t.scrollIntoView && t.parentNode.scrollWidth > t.parentNode.clientWidth) {
          var box = t.parentNode, left = t.offsetLeft - (box.clientWidth - t.offsetWidth) / 2;
          box.scrollTo({ left: left, behavior: 'smooth' });
        }
      });
      if (counter) counter.textContent = pad(current + 1) + ' / ' + pad(slides.length);
    }
    var prev = section.querySelector('[data-pairs-prev]');
    var next = section.querySelector('[data-pairs-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    thumbs.forEach(function (t, k) {
      t.addEventListener('click', function () { show(k); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); show(current + 1); thumbs[current].focus(); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); show(current - 1); thumbs[current].focus(); }
      });
    });
    if (stage && slides.length > 1) {
      var x0 = null, y0 = null;
      stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) show(current + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }
    var box = section.querySelector('[data-pairs-lightbox]');
    var boxImg = section.querySelector('[data-pairs-lightbox-img]');
    var boxScroll = section.querySelector('[data-pairs-lightbox-scroll]');
    if (box && boxImg && typeof box.showModal === 'function') {
      section.addEventListener('click', function (e) {
        var z = e.target.closest('[data-pairs-zoom]');
        if (!z) return;
        boxImg.src = z.getAttribute('data-zoom-src');
        boxImg.alt = z.getAttribute('data-zoom-alt') || '';
        box.setAttribute('data-kind', z.getAttribute('data-zoom-kind') || 'desktop');
        if (boxScroll) boxScroll.scrollTop = 0;
        box.showModal();
      });
      var close = section.querySelector('[data-pairs-close]');
      if (close) close.addEventListener('click', function () { box.close(); });
      box.addEventListener('click', function (e) { if (e.target === box) box.close(); });
      box.addEventListener('close', function () { boxImg.removeAttribute('src'); });
    }
    thumbs.forEach(function (t, k) { t.tabIndex = k === 0 ? 0 : -1; });
  }
  function boot() { [].forEach.call(document.querySelectorAll('[data-pairs]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();